const { find } = require('lodash');

class ManualAddressController {
    constructor(addressService, moveFocus, $q, settings) {
        this.addressService = addressService;
        this.moveFocus = moveFocus;
        this.$q = $q;

        this.maxCharactersManualAddress1 = settings.oneSite.maxCharactersManualAddress1;
        this.maxCharactersManualAddress2 = settings.oneSite.maxCharactersManualAddress2;
    }

    addressChange() {
        if (this.onAddressChange) {
            this.onAddressChange({ address: this.address });
        }
    }

    $onInit() {
        this.moveFocus('#manualAddress');
        if (!this.initialAddress) {
            this.clearInput();
        }
    }

    $onChanges(changes) {
        if (changes.initialAddress && this.initialAddress) {
            this.clearInput();
            this.useInitialAddress(this.initialAddress);
        }
    }

    clearInput() {
        this.address = { postcode: '', street1: '', street2: '', suburbId: null, suburb: '' };
        this.suburbs = [];
    }

    useInitialAddress(address) {
        this.address.postcode = address.postcode;
        this.loadSuburbs().then(() => {
            const initialSuburb = this.getInitialSuburb(address);
            this.address = {
                postcode: address.postcode,
                street1: address.street1,
                street2: address.street2,
                suburbId: initialSuburb.Id,
                suburb: initialSuburb.Text,
            };
            this.setSuburb({
                Id: initialSuburb.Id,
                Text: initialSuburb.Text,
            });
        });
    }

    getInitialSuburb(address) {
        return address.suburbId
            ? {
                Id: address.suburbId,
                Text: address.suburbName,
            }
            : this.getSuburbByName(address.suburbName);
    }

    getSuburbByName(suburbName) {
        return (suburbName && this.suburbs && this.suburbs.length)
            ? find(this.suburbs, item => item.Text.toLowerCase() === suburbName.toLowerCase())
            : { Id: '', Text: '' };
    }

    setSuburb(suburb) {
        if (suburb) {
            this.address.suburbId = !suburb.Id || suburb.Id === 'n/a' ? 0 : suburb.Id;
            this.address.suburb = suburb.Text;
            this.selectedSuburb = suburb;
            this.addressChange();
        }
        return this.selectedSuburb;
    }

    loadSuburbs() {
        if (this.address.postcode && this.address.postcode.length === 4) {
            return this.addressService.getSuburbs(this.address.postcode).then((suburbs) => {
                this.suburbs = suburbs;
                if (this.suburbs && this.suburbs.length) {
                    this.setSuburb(this.suburbs[0]);
                }

                this.addressChange();
            });
        }
        return this.$q.reject();
    }

    onSubmit() {
        this.onAddressSaved({ address: this.address });
    }
}

const manualAddressComponentDefinition = {
    bindings: {
        initialAddress: '<?',
        messageOnError: '@?',
        onAddressSaved: '&',
        onAddressChange: '&?',
        showSubmit: '<',
    },
    controller: ['AddressService', 'MoveFocus', '$q', 'Settings', ManualAddressController],
    template: require('./manual-address.component.html').trim(),
};

module.exports = {
    ManualAddressController,
    manualAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/manual-address.component.js